import { initApp } from './app'

// Initialize app asynchronously to restore auth session
initApp().then((app) => {
  app.mount('#app')
})
